// Coleções e a fila "jogar em seguida" vivem no dispositivo (localStorage),
// separadas da biblioteca principal no Firestore.

const listsKey = (uid) => `ja-joguei-lists-${uid}`;
const queueKey = (uid) => `ja-joguei-queue-${uid}`;

const readJSON = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

export const getLists = (uid) => readJSON(listsKey(uid), []);
export const saveLists = (uid, lists) => localStorage.setItem(listsKey(uid), JSON.stringify(lists));

export const createList = (uid, name) => {
  const lists = getLists(uid);
  const newList = { id: `list-${Date.now()}`, name: name.trim(), gameIds: [] };
  const updated = [...lists, newList];
  saveLists(uid, updated);
  return updated;
};

export const deleteList = (uid, listId) => {
  const updated = getLists(uid).filter(list => list.id !== listId);
  saveLists(uid, updated);
  return updated;
};

export const toggleGameInList = (uid, listId, gameId) => {
  const updated = getLists(uid).map(list => {
    if (list.id !== listId) return list;
    const inList = list.gameIds.includes(gameId);
    return { ...list, gameIds: inList ? list.gameIds.filter(id => id !== gameId) : [...list.gameIds, gameId] };
  });
  saveLists(uid, updated);
  return updated;
};

export const MAX_QUEUE_SIZE = 5;

export const getQueue = (uid) => readJSON(queueKey(uid), []);
export const saveQueue = (uid, queue) => localStorage.setItem(queueKey(uid), JSON.stringify(queue));

export const addToQueue = (uid, gameId) => {
  const queue = getQueue(uid);
  if (queue.includes(gameId) || queue.length >= MAX_QUEUE_SIZE) return queue;
  const updated = [...queue, gameId];
  saveQueue(uid, updated);
  return updated;
};

export const removeFromQueue = (uid, gameId) => {
  const updated = getQueue(uid).filter(id => id !== gameId);
  saveQueue(uid, updated);
  return updated;
};

export const moveInQueue = (uid, gameId, direction) => {
  const queue = getQueue(uid);
  const index = queue.indexOf(gameId);
  const targetIndex = index + direction;
  if (index === -1 || targetIndex < 0 || targetIndex >= queue.length) return queue;
  const updated = [...queue];
  [updated[index], updated[targetIndex]] = [updated[targetIndex], updated[index]];
  saveQueue(uid, updated);
  return updated;
};
